import { render, staticRenderFns } from "./NewsWall.vue?vue&type=template&id=7295bc9a&scoped=true&"
import script from "./NewsWall.vue?vue&type=script&lang=js&"
export * from "./NewsWall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7295bc9a",
  null
  
)

export default component.exports